import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useMemo, useState, useEffect, } from 'react';
import { PREFIX_BS } from '../config';
import DIcon from '../DIcon';
import { useDContext } from '../../contexts';
export default function DCollapse({ id, className, style, Component, hasSeparator = false, defaultCollapsed = true, onChange, children, iconOpen: iconOpenProp, iconClose: iconCloseProp, iconFamilyClass, iconFamilyPrefix, iconMaterialStyle = false, dataAttributes, }) {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);
    const onChangeCollapse = () => {
        setCollapsed((prev) => {
            const next = !prev;
            if (onChange) {
                onChange(next);
            }
            return next;
        });
    };
    useEffect(() => {
        setCollapsed(defaultCollapsed);
    }, [defaultCollapsed]);
    const { iconMap: { chevronDown, chevronUp, }, } = useDContext();
    const iconOpen = useMemo(() => iconOpenProp || chevronDown, [chevronDown, iconOpenProp]);
    const iconClose = useMemo(() => iconCloseProp || chevronUp, [chevronUp, iconCloseProp]);
    const generateStyles = useMemo(() => ({
        [`--${PREFIX_BS}collapse-separator-display`]: hasSeparator ? 'block' : 'none',
    }), [hasSeparator]);
    return (_jsxs("div", Object.assign({ id: id, className: classNames('collapse-container', className), style: style }, dataAttributes, { children: [_jsxs("button", { className: "collapse-button", type: "button", onClick: onChangeCollapse, children: [_jsx("div", { className: "flex-grow-1", children: Component }), _jsx(DIcon, { color: "gray", size: "1rem", icon: collapsed ? iconOpen : iconClose, familyClass: iconFamilyClass, familyPrefix: iconFamilyPrefix, materialStyle: iconMaterialStyle })] }), !collapsed && (_jsx("div", { className: classNames({
                    'collapse-body': true,
                }), style: generateStyles, children: children }))] })));
}
//# sourceMappingURL=DCollapse.js.map